import { render } from "./02_ContactInfoSection.vue?vue&type=template&id=b25af67a"
import script from "./02_ContactInfoSection.vue?vue&type=script&lang=js"
export * from "./02_ContactInfoSection.vue?vue&type=script&lang=js"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__